import { render, staticRenderFns } from "./ThemeSelector.vue?vue&type=template&id=394aa58e&scoped=true&"
import script from "./ThemeSelector.vue?vue&type=script&lang=js&"
export * from "./ThemeSelector.vue?vue&type=script&lang=js&"
import style0 from "./ThemeSelector.vue?vue&type=style&index=0&id=394aa58e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394aa58e",
  null
  
)

export default component.exports